<template lang="html">
  <div style="padding-top: 0; margin-top: 0">

    <div ref="espelhoDaProposta">

      <!-- Botão para imprimir a tela (espelho da proposta em PDF) -->
      <v-layout style="position: absolute; z-index: 1; left: 40px; top: 40px">
        <v-btn class="btnGerarPDF" color="primary" onclick="window.print()">Gerar PDF</v-btn>
      </v-layout>

      <br><br>

      <v-layout justify-center>
        <h2 style="align: center; margin: 0px 20px;">{{ relatorio.classificacoes[1].descricao }} nº
          {{ this.relatorio.informacoes.idProjeto }} - {{ this.relatorio.informacoes.titulo }}</h2>
      </v-layout>
      <br>

      <!-- Informações -->
      <v-layout>
        <v-flex xs12>
          <v-toolbar text dense :color="'primary white--text'" class="text-xs-center">
            <v-toolbar-title style="width: 100%">Informações</v-toolbar-title>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <br>

      <v-layout row>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Título"
            :value="this.relatorio.informacoes.titulo"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Número"
            :value="this.relatorio.informacoes.idProjeto"></c-readonly-field>
        </v-flex>
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Situação"
            :value="this.relatorio.informacoes.situacao.descricao"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Tipo de público-alvo"
            :value="this.relatorio.informacoes.tipoPublico.descricao"></c-readonly-field>
        </v-flex>
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Público-alvo estimado"
            :value="this.relatorio.informacoes.publicoAlvo || ' '"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row
        v-if="relatorio.classificacoes && (relatorio.classificacoes[1].id === 39729 || relatorio.classificacoes[1].id === 44194 || relatorio.classificacoes[1].id === 44195)">
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label='Carga horária do curso'
            :value="this.relatorio.informacoes.cargaHoraria || ' '"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Data de início"
            :value="relatorio.informacoes.dataInicio ? dates.format(relatorio.informacoes.dataInicio) || '-' : '-'"></c-readonly-field>
        </v-flex>
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Data de conclusão"
            :value="relatorio.informacoes.dataConclusao ? dates.format(relatorio.informacoes.dataConclusao) || '-' : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs3>
          <c-readonly-field style="margin: 0px 30px;" label="Palavra-chave 1"
            :value="this.relatorio.informacoes.palavraChave01 || ' '"></c-readonly-field>
        </v-flex>
        <v-flex xs3>
          <c-readonly-field style="margin: 0px 30px;" label="Palavra-chave 2"
            :value="this.relatorio.informacoes.palavraChave02 || ' '"></c-readonly-field>
        </v-flex>
        <v-flex xs3>
          <c-readonly-field style="margin: 0px 30px;" label="Palavra-chave 3"
            :value="this.relatorio.informacoes.palavraChave03 || ' '"></c-readonly-field>
        </v-flex>
        <v-flex xs3>
          <c-readonly-field style="margin: 0px 30px;" label="Palavra-chave 4"
            :value="this.relatorio.informacoes.palavraChave04 || ' '"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <c-readonly-field style="margin: 0px 30px;" align="justify" label="Resumo"
          :value="this.relatorio.informacoes.resumo || '-'"></c-readonly-field>
      </v-layout>
      <br>

      <!-- Classificações -->
      <v-layout>
        <v-flex xs12>
          <v-toolbar text dense :color="'primary white--text'" class="text-xs-center">
            <v-toolbar-title style="width: 100%">Classificações</v-toolbar-title>
          </v-toolbar>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers0" :items="relatorio.classificacoes" :items-per-page="-1" hide-default-footer>
        <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
          Total de {{ relatorio.classificacoes.length }} classificações
        </template>
      </v-data-table>
      <br>

      <!-- Extensão -->
      <v-layout>
        <v-flex xs12>
          <v-toolbar text dense :color="'primary white--text'" class="text-xs-center">
            <v-toolbar-title style="width: 100%">Extensão</v-toolbar-title>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <br>

      <v-layout row wrap justify-space-between>
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Unidade"
            :value="relatorio.extensao.unidade ? relatorio.extensao.unidade.nome : '-'"></c-readonly-field>
        </v-flex>
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Órgão competente pela aprovação"
            :value="relatorio.extensao.orgaoCompetente ? relatorio.extensao.orgaoCompetente : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-space-between>
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Coordenado por"
            :value="relatorio.extensao.coordenadoPor ? relatorio.extensao.coordenadoPor.descricao : '-'"></c-readonly-field>
        </v-flex>
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Data da primeira apresentação"
            :value="relatorio.extensao.dtPrimeiraApresentacao ? dates.format(relatorio.extensao.dtPrimeiraApresentacao) || '-' : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-space-between>
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Data da última revisão"
            :value="relatorio.extensao.dtRevisao ? dates.format(relatorio.extensao.dtRevisao) || '-' : '-'"></c-readonly-field>
        </v-flex>

        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Data de aprovação pela Câmara de Extensão"
            :value="relatorio.extensao.dtAprovacao ? dates.format(relatorio.extensao.dtAprovacao) || '-' : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row v-if="relatorio.informacoes.situacao.item === 17">
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Data de inabilitação pela Câmara de Extensão"
            :value="relatorio.extensao.dtInabilitacao ? dates.format(relatorio.extensao.dtInabilitacao) || '-' : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row v-if="relatorio.extensao.discenteCoordenador">
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Discente Coordenador"
            :value="relatorio.extensao.nomeDiscenteCoordenador || '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-space-between v-if="relatorio.extensao.evento">
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="Tipo de Evento"
            :value="relatorio.extensao.tipoEvento ? relatorio.extensao.tipoEvento.descricao : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- O programa é uma Empresa Júnior? -->
      <v-layout row wrap justify-space-between v-if="relatorio.classificacoes[1].id === 39733">
        <v-flex xs6>
          <c-readonly-field style="margin: 0px 30px;" label="O programa é uma Empresa Júnior?"
            :value="relatorio.extensao.empresaJunior != null ? (relatorio.extensao.empresaJunior ? 'Sim' : 'Não') : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Texto informativo sobre o cadastro de empresas juniores como programas -->
      <v-layout row wrap justify-space-between v-if="relatorio.classificacoes[1].id === 39733">
        <v-flex xs12>
          <v-alert class="alertaEmpresaJunior" color="#00796b" type="info" dense outlined>
            Conforme os Artigos 03, 06 e 10 da Resolução nº.10/2019 do Conselho Universitário, as empresas juniores
            deverão ser cadastradas na Pró-Reitoria de Extensão – PROEX como Programa de Extensão.
          </v-alert>
          <br>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" align="justify" label="Apresentação"
            :value="this.relatorio.extensao.apresentacao || '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" align="justify" label="Justificativa / Mérito extensionista"
            :value="this.relatorio.extensao.justificativa || '-'">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row v-if="this.relatorio.extensao.caracterizacaoPublicoAlvo">
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" align="justify" label="Caracterização do público-alvo"
            :value="this.relatorio.extensao.caracterizacaoPublicoAlvo || '-'">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row
        v-if="!this.relatorio.extensao.caracterizacaoPublicoAlvo && this.relatorio.informacoes.tipoPublico.item === 1">
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" align="justify" label="Caracterização do público-alvo interno"
            :value="this.relatorio.extensao.publicoAlvoInterno || '-'">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row v-if="!this.relatorio.extensao.caracterizacaoPublicoAlvo">
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" align="justify" label="Caracterização do público-alvo externo"
            :value="this.relatorio.extensao.publicoAlvoExterno || '-'">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" align="justify" label="Objetivo geral"
            :value="this.relatorio.extensao.objetivosGerais || '-'">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12>
          <label style="font-size: 16px; margin: 0px 30px">Objetivos específicos</label>
          <p style="font-size: 16px; margin: 0px 30px; overflow-wrap: break-word;"
            v-for="(item, index) in objetivosEspecificosTopicos" :key="item.id" align="justify">
            {{ index + 1 }}. {{ item.nome }}
            <br>
          </p>
        </v-flex>
      </v-layout>
      <br>

      <v-layout row>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Metodologia" align="justify"
            :value="this.relatorio.extensao.metodologia || '-'">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Formas de avaliação -->
      <v-layout row>

        <v-flex xs12>

          <!-- Curso ou Oficina de Extensão -->
          <c-readonly-field v-if="relatorio.extensao.curso" style="margin: 0px 30px;" align="justify"
            label="Formas de avaliação dos cursistas" :value="this.relatorio.extensao.formaAvaliacao || '-'">
          </c-readonly-field>

          <!-- Demais tipos de ação de extensão -->
          <c-readonly-field v-else style="margin: 0px 30px;" align="justify" label="Forma de avaliação"
            :value="this.relatorio.extensao.formaAvaliacao || '-'">
          </c-readonly-field>

        </v-flex>

      </v-layout>

      <v-layout row>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" align="justify" label="Infraestrutura física"
            :value="this.relatorio.extensao.infraestruturaFisica || '-'">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Apresentar justificativa pelo cadastro/envio da ação ter sido realizado em prazo inferior ao estabelecido pela Instrução Normativa nº 02/2016 >
      <v-layout row v-if="this.prazo < 30 && !this.relatorio.extensao.registroSIEX">
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" align="justify"
            label="Apresentar justificativa pelo cadastro/envio da ação ter sido realizado em prazo inferior ao estabelecido pela Instrução Normativa nº 02/2016"
            :value="this.relatorio.extensao.justificativaPrazo || '-'">
          </c-readonly-field>
        </v-flex>
      </v-layout>
      <v-layout row v-if="this.prazo < 30 && !this.relatorio.extensao.registroSIEX">
        <v-flex xs12>
          <v-alert class="alertaPrazo" color="#00796b" type="info" dense outlined>
            O coordenador de Ação de Extensão deverá proceder ao registro prévio e encaminhamento da documentação
            pertinente à PROEX, com antecedência mínima de 30 (trinta) dias úteis ao início da Ação, conforme Instrução
            Normativa nº 02/2016.
          </v-alert>
        </v-flex>
      </v-layout-->

      <v-layout row>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" align="justify" label="Informações adicionais"
            :value="this.relatorio.extensao.informacoesAdicionais || '-'">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.length !== 0">
        <v-flex xs12>
          <label style="margin: 0px 30px;">Tipo de Prestação de Serviço</label>
          <v-select style="margin: 0px 30px;" v-model="listaTiposPrestacaoServicoSelecionados"
            :items="listaTiposPrestacaoServico" chips multiple readonly>
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.length === 0">
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Tipo de Prestação de Serviço" :value="'-'"
            align="justify"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')">
        <v-flex xs12>
          <p class="tipoPrestacaoServico">Tipo: Atendimento ao público em espaços de cultura, ciência e tecnologia</p>
          <!-- Espaços e Museus Culturais -->
          <v-checkbox style="margin: 0px 30px;" v-model="listaAtendimentoPublicoEspacosSelecionados"
            value="Espaços e Museus Culturais" readonly>
            <template v-slot:label>
              <div>Espaços e Museus Culturais</div>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')">
        <v-flex xs12>
          <!-- Espaços e Museus de Ciência e Tecnologia -->
          <v-checkbox style="margin: 0px 30px;" v-model="listaAtendimentoPublicoEspacosSelecionados"
            value="Espaços e Museus de Ciência e Tecnologia" readonly>
            <template v-slot:label>
              <div>Espaços e Museus de Ciência e Tecnologia</div>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')">
        <v-flex xs12>
          <!-- Cines-clube -->
          <v-checkbox style="margin: 0px 30px;" v-model="listaAtendimentoPublicoEspacosSelecionados" value="Cines-clube"
            readonly>
            <template v-slot:label>
              <div>Cines-clube</div>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')">
        <v-flex xs12>
          <!-- Outros -->
          <v-checkbox style="margin: 0px 30px;" v-model="listaAtendimentoPublicoEspacosSelecionados" value="Outros"
            readonly>
            <template v-slot:label>
              <div>Outros</div>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Serviço eventual) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')">
        <v-flex xs4>
          <p class="tipoPrestacaoServico">Tipo: Serviço eventual</p>
          <!-- Nº de assessorias -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de assessorias'
            v-model="this.relatorio.extensao.numAssessorias" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Serviço eventual) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')">
        <v-flex xs4>
          <!-- Nº de consultorias -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de consultorias'
            v-model="this.relatorio.extensao.numConsultorias" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Serviço eventual) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')">
        <v-flex xs4>
          <!-- Nº de curadorias -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de curadorias'
            v-model="this.relatorio.extensao.numCuradorias" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Serviço eventual) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')">
        <v-flex xs4>
          <!-- Nº de outros -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de outros'
            v-model="this.relatorio.extensao.numOutrosServicos" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atividades de propriedade intelectual) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')">
        <v-flex xs4>
          <p class="tipoPrestacaoServico">Tipo: Atividades de propriedade intelectual</p>
          <!-- Nº de depósito de patentes e modelos de utilidades -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de depósito de patentes e modelos de utilidades'
            v-model="this.relatorio.extensao.numPatentesModelos" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atividades de propriedade intelectual) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')">
        <v-flex xs4>
          <!-- Nº de registro de marcas e softwares -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de registro de marcas e softwares'
            v-model="this.relatorio.extensao.numMarcasSoftwares" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atividades de propriedade intelectual) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')">
        <v-flex xs4>
          <!-- Nº de contratos de transferência de tecnologia -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de contratos de transferência de tecnologia'
            v-model="this.relatorio.extensao.numTransferenciaTecnologia" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atividades de propriedade intelectual) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')">
        <v-flex xs4>
          <!-- Nº de registros de direitos autorais -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de registros de direitos autorais'
            v-model="this.relatorio.extensao.numDireitosAutorais" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Exames e laudos técnicos) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos')">
        <v-flex xs4>
          <p class="tipoPrestacaoServico">Tipo: Exames e laudos técnicos</p>
          <!-- Nº de laudos emitidos -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de laudos emitidos'
            v-model="this.relatorio.extensao.numLaudosEmitidos" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento jurídico) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico')">
        <v-flex xs4>
          <p class="tipoPrestacaoServico">Tipo: Atendimento jurídico</p>
          <!-- Nº de atendimentos -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de atendimentos'
            v-model="this.relatorio.extensao.numAtendimentosJuridicos" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
        <v-flex xs4>
          <p class="tipoPrestacaoServico">Tipo: Atendimento em saúde humana</p>
          <!-- Nº de consultas ambulatoriais (programadas) -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de consultas ambulatoriais (programadas)'
            v-model="this.relatorio.extensao.numConsultasAmbulatoriais" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
        <v-flex xs4>
          <!-- Nº de consultas de emergência e urgência -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de consultas de emergência e urgência'
            v-model="this.relatorio.extensao.numConsultasEmergencia" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
        <v-flex xs4>
          <!-- Nº de internações -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de internações'
            v-model="this.relatorio.extensao.numInternacoes" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
        <v-flex xs4>
          <!-- Nº de cirurgias -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de cirurgias'
            v-model="this.relatorio.extensao.numCirurgias" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
        <v-flex xs4>
          <!-- Nº de exames laboratoriais -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de exames laboratoriais'
            v-model="this.relatorio.extensao.numExamesLaboratoriais" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
        <v-flex xs4>
          <!-- Nº de exames complementares -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de exames complementares'
            v-model="this.relatorio.extensao.numExamesComplementares" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento em saúde humana) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')">
        <v-flex xs4>
          <!-- Nº de outros atendimentos -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de outros atendimentos'
            v-model="this.relatorio.extensao.numOutrosAtendimentosSH" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento em saúde animal) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')">
        <v-flex xs4>
          <p class="tipoPrestacaoServico">Tipo: Atendimento em saúde animal</p>
          <!-- Nº de atendimentos veterinários ambulatoriais -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de atendimentos veterinários ambulatoriais'
            v-model="this.relatorio.extensao.numAtendimentosVeterinarios" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento em saúde animal) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')">
        <v-flex xs4>
          <!-- Nº de internações veterinárias -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de internações veterinárias'
            v-model="this.relatorio.extensao.numInternacoesVeterinarias" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento em saúde animal) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')">
        <v-flex xs4>
          <!-- Nº de cirurgias veterinárias -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de cirurgias veterinárias'
            v-model="this.relatorio.extensao.numCirurgiasVeterinarias" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Tipo de Prestação de Serviço (Atendimento em saúde animal) -->
      <v-layout row wrap
        v-if="this.relatorio.extensao.prestacaoServico && listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')">
        <v-flex xs4>
          <!-- Nº de exames laboratoriais e complementares em veterinária -->
          <c-readonly-field style="margin: 0px 30px;" label='Nº de exames laboratoriais e complementares em veterinária'
            v-model="this.relatorio.extensao.numExamesVeterinaria" :rules="campoNumericoRules">
          </c-readonly-field>
        </v-flex>
      </v-layout>

      <p v-if="this.relatorio.extensao.prestacaoServico" style="margin: 2em;"></p>

      <v-layout row wrap justify-space-between>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Possui vínculo com ensino"
            :value="relatorio.extensao.vinculoEnsino != null ? (relatorio.extensao.vinculoEnsino ? 'Sim' : 'Não') : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-space-between>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Possui vínculo com pesquisa"
            :value="relatorio.extensao.vinculoPesquisa != null ? (relatorio.extensao.vinculoPesquisa ? 'Sim' : 'Não') : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Esta ação realiza divulgação científica -->
      <v-layout row wrap justify-space-between>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Esta ação realiza divulgação científica"
            :value="relatorio.extensao.divulgacaoCientifica != null ? (relatorio.extensao.divulgacaoCientifica ? 'Sim' : 'Não') : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Envolve captação de recursos financeiros ou bens duráveis -->
      <v-layout row wrap justify-space-between>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Envolve captação de recursos financeiros ou bens duráveis"
            :value="relatorio.extensao.captacaoRecursosBensDuraveis != null ? (relatorio.extensao.captacaoRecursosBensDuraveis ? 'Sim' : 'Não') : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Por meio de: -->
      <v-layout row wrap justify-space-between v-if="relatorio.extensao.captacaoRecursosBensDuraveis === true">
        <v-flex xs12>
          <div style="margin: 0px 30px;"><label>Por meio de:</label></div>
        </v-flex>
      </v-layout>

      <div v-if="relatorio.extensao.captacaoRecursosBensDuraveis === true"><br></div>
      <v-layout row wrap justify-space-between v-if="relatorio.extensao.captacaoRecursosBensDuraveis === true">

        <!-- UFES -->
        <v-flex xs4 sm4>
          <v-checkbox style="margin: 0px 30px;" v-model="relatorio.extensao.captacaoRecursosUfes" readonly>
            <template v-slot:label>
              <div class="v-checkbox_label">UFES</div>
            </template>
          </v-checkbox>
        </v-flex>

        <!-- CAPES -->
        <v-flex xs4 sm4>
          <v-checkbox v-model="relatorio.extensao.captacaoRecursosCapes" readonly>
            <template v-slot:label>
              <div class="v-checkbox_label">CAPES</div>
            </template>
          </v-checkbox>
        </v-flex>

        <!-- FEST -->
        <v-flex xs4 sm4>
          <v-checkbox v-model="relatorio.extensao.captacaoRecursosFest" readonly>
            <template v-slot:label>
              <div class="v-checkbox_label">FEST</div>
            </template>
          </v-checkbox>
        </v-flex>

      </v-layout>

      <v-layout row wrap justify-space-between v-if="relatorio.extensao.captacaoRecursosBensDuraveis === true">

        <!-- CNPq -->
        <v-flex xs4 sm4>
          <v-checkbox style="margin: 0px 30px;" v-model="relatorio.extensao.captacaoRecursosCnpq" readonly>
            <template v-slot:label>
              <div class="v-checkbox_label">CNPq</div>
            </template>
          </v-checkbox>
        </v-flex>

        <!-- FAPES -->
        <v-flex xs4 sm4>
          <v-checkbox v-model="relatorio.extensao.captacaoRecursosFapes" readonly>
            <template v-slot:label>
              <div class="v-checkbox_label">FAPES</div>
            </template>
          </v-checkbox>
        </v-flex>

        <!-- FUCAM -->
        <v-flex xs4 sm4>
          <v-checkbox v-model="relatorio.extensao.captacaoRecursosFucam" readonly>
            <template v-slot:label>
              <div class="v-checkbox_label">FUCAM</div>
            </template>
          </v-checkbox>
        </v-flex>

      </v-layout>

      <v-layout row wrap justify-space-between v-if="relatorio.extensao.captacaoRecursosBensDuraveis === true">

        <!-- Outros -->
        <v-flex xs4 sm4>
          <v-checkbox style="margin: 0px 30px;" v-model="relatorio.extensao.captacaoRecursosOutros" readonly>
            <template v-slot:label>
              <div class="v-checkbox_label">Outros</div>
            </template>
          </v-checkbox>
        </v-flex>
        <v-flex xs8 sm8>
          <c-readonly-field label="Especifique:" v-model="relatorio.extensao.especCaptacaoRecursosOutros">
          </c-readonly-field>
        </v-flex>

      </v-layout>

      <!-- Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação -->
      <v-layout row wrap justify-space-between>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;"
            label="Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação"
            :value="relatorio.extensao.liberacaoCargaHoraria != null ? (relatorio.extensao.liberacaoCargaHoraria ? 'Sim' : 'Não') : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Carga horária aprovada -->
      <v-layout row wrap justify-space-between v-if="relatorio.extensao.liberacaoCargaHoraria === true">
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Carga horária aprovada"
            :value="this.relatorio.extensao.cargaHorariaCoordenadorAprovada || '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Gratuito para o público -->
      <v-layout row wrap justify-space-between v-if="relatorio.extensao.curso || relatorio.extensao.evento">
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Gratuito para o público"
            :value="relatorio.extensao.gratuito != null ? (relatorio.extensao.gratuito ? 'Sim' : 'Não') : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Os recursos financeiros obtidos serão administrados por: -->
      <v-layout row wrap justify-space-between v-if="relatorio.extensao.gratuito === false">
        <v-flex xs12>
          <div style="margin: 0px 30px;"><label>Os recursos financeiros obtidos serão administrados por:</label></div>
        </v-flex>
      </v-layout>

      <div v-if="relatorio.extensao.gratuito === false"><br></div>

      <!-- UFES -->
      <v-layout row wrap justify-space-between v-if="relatorio.extensao.gratuito === false">
        <v-flex xs4 sm4>
          <v-checkbox style="margin: 0px 30px;" v-model="relatorio.extensao.gratuitoUfes" readonly>
            <template v-slot:label>
              <div class="v-checkbox_label">UFES</div>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>

      <!-- FEST-->
      <v-layout row wrap justify-space-between v-if="relatorio.extensao.gratuito === false">
        <v-flex xs4 sm4>
          <v-checkbox style="margin: 0px 30px;" v-model="relatorio.extensao.gratuitoFest" readonly>
            <template v-slot:label>
              <div class="v-checkbox_label">FEST</div>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>

      <!-- FUCAM -->
      <v-layout row wrap justify-space-between v-if="relatorio.extensao.gratuito === false">
        <v-flex xs4 sm4>
          <v-checkbox style="margin: 0px 30px;" v-model="relatorio.extensao.gratuitoFucam" readonly>
            <template v-slot:label>
              <div class="v-checkbox_label">FUCAM</div>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-space-between v-if="relatorio.extensao.gratuito === false">

        <!-- Outros -->
        <v-flex xs4 sm4>
          <v-checkbox style="margin: 0px 30px;" v-model="relatorio.extensao.gratuitoOutros" readonly>
            <template v-slot:label>
              <div class="v-checkbox_label">Outros</div>
            </template>
          </v-checkbox>
        </v-flex>
        <v-flex xs8 sm8>
          <c-readonly-field label="Especifique:" v-model="relatorio.extensao.especGratuitoOutros">
          </c-readonly-field>
        </v-flex>

      </v-layout>

      <!-- Modalidade -->
      <v-layout row wrap justify-space-between v-if="relatorio.extensao.curso">
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Modalidade"
            :value="relatorio.extensao.modalidade != null ? (relatorio.extensao.modalidade == 'P' ? 'Presencial' : (relatorio.extensao.modalidade == 'S' ? 'Semipresencial' : 'EAD')) : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Utiliza o AVA Extensão -->
      <v-layout row wrap justify-space-between v-if="relatorio.extensao.curso">
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Utiliza o AVA Extensão"
            :value="relatorio.extensao.utilizaAvaExtensao != null ? (relatorio.extensao.utilizaAvaExtensao ? 'Sim' : 'Não') : '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Outra plataforma AVA -->
      <v-layout row wrap justify-space-between v-if="relatorio.extensao.curso">
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Outra plataforma AVA"
            :value="relatorio.extensao.plataforma || '-'"></c-readonly-field>
        </v-flex>
      </v-layout>
      <br>

      <!-- Equipe -->
      <v-layout>
        <v-flex xs12>
          <v-toolbar text dense :color="'primary white--text'" class="text-xs-center">
            <v-toolbar-title style="width: 100%">Equipe</v-toolbar-title>
          </v-toolbar>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers1" :items="relatorio.equipe" :items-per-page="-1" hide-default-footer
        :no-data-text="'Este projeto não possui integrantes.'">
        <template v-slot:item.assessor="props">{{ formatAssessor.format(props.item.assessor,
          props.item.funcao.item) }}</template>
        <template v-slot:item.dataInicial="props">{{ dates.format(props.item.dataInicial) }}</template>
        <template v-slot:item.dataFinal="props">{{ dates.format(props.item.dataFinal) }}</template>
        <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
          Total de {{ relatorio.equipe.length }} integrantes
        </template>
      </v-data-table>
      <br>

      <!-- Atividades -->
      <v-layout>
        <v-flex xs12>
          <v-toolbar text dense :color="'primary white--text'" class="text-xs-center">
            <v-toolbar-title style="width: 100%">Atividades</v-toolbar-title>
          </v-toolbar>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers2" :items="relatorio.atividades" :items-per-page="-1" hide-default-footer
        :no-data-text="'Este projeto não possui atividades.'">
        <template v-slot:item.nomeDescricao="props">
          <div v-if="props.item.detalhamento !== null && props.item.detalhamento !== ''">
            {{ props.item.descricao }}<br><br>{{ props.item.detalhamento }}</div>
          <div v-else>{{ props.item.descricao }}</div>
        </template>
        <template v-slot:item.dtInicioPrevisto="props">{{ dates.format(props.item.dtInicioPrevisto) }}</template>
        <template v-slot:item.dtFimPrevisto="props">{{ dates.format(props.item.dtFimPrevisto) }}</template>
        <template v-slot:item.dtInicioEfetivo="props">{{ dates.format(props.item.dtInicioEfetivo) }}</template>
        <template v-slot:item.dtFimEfetivo="props">{{ dates.format(props.item.dtFimEfetivo) }}</template>
        <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
          Total de {{ relatorio.atividades.length }} atividades
        </template>
      </v-data-table>
      <br>

      <!-- Vínculos -->
      <v-layout>
        <v-flex xs12>
          <v-toolbar text dense :color="'primary white--text'" class="text-xs-center">
            <v-toolbar-title style="width: 100%">Vínculos</v-toolbar-title>
          </v-toolbar>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers2b" :items="relatorio.vinculos" :items-per-page="-1" hide-default-footer
        :no-data-text="'Este projeto não possui vínculos.'">
        <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
          Total de {{ relatorio.vinculos.length }} vínculos
        </template>
      </v-data-table>
      <br>

      <!-- Parcerias -->
      <v-layout>
        <v-flex xs12>
          <v-toolbar text dense :color="'primary white--text'" class="text-xs-center">
            <v-toolbar-title style="width: 100%">Parcerias</v-toolbar-title>
          </v-toolbar>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers3" :items="relatorio.parcerias" :items-per-page="-1" hide-default-footer
        :no-data-text="'Este projeto não possui parcerias.'">
        <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
          Total de de {{ relatorio.parcerias.length }} parcerias
        </template>
      </v-data-table>
      <br>

      <!-- Abrangência -->
      <v-layout>
        <v-flex xs12>
          <v-toolbar text dense :color="'primary white--text'" class="text-xs-center">
            <v-toolbar-title style="width: 100%">Abrangência</v-toolbar-title>
          </v-toolbar>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers4" :items="relatorio.abrangencia" :items-per-page="-1" hide-default-footer
        :no-data-text="'Este projeto não possui localidades.'">
        <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
          Total de {{ relatorio.abrangencia.length }} localidades
        </template>
      </v-data-table>
      <br>

      <!-- Arquivos -->
      <v-layout>
        <v-flex xs12>
          <v-toolbar text dense :color="'primary white--text'" class="text-xs-center">
            <v-toolbar-title style="width: 100%">Arquivos</v-toolbar-title>
          </v-toolbar>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers5" :items="relatorio.arquivos" :items-per-page="-1" hide-default-footer
        :no-data-text="'Este projeto não possui arquivos.'">
        <template v-slot:item.dtInclusao="props">{{ dates.format(props.item.dtInclusao) }}</template>
        <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
          Total de {{ relatorio.arquivos.length }} arquivos
        </template>
      </v-data-table>
      <br>

      <!-- Contatos -->
      <v-layout>
        <v-flex xs12>
          <v-toolbar text dense :color="'primary white--text'" class="text-xs-center">
            <v-toolbar-title style="width: 100%">Contatos</v-toolbar-title>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <br>

      <!-- Site -->
      <v-layout row>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Site"
            :value="relatorio.contatos.site || '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Mídias sociais -->
      <v-layout row>
        <v-flex xs12>
          <c-readonly-field-pre-format style="margin: 0px 30px;" label="Mídias sociais"
            :value="relatorio.contatos.midiasSociais || '-'"></c-readonly-field-pre-format>
        </v-flex>
      </v-layout>

      <!-- Nome do contato -->
      <v-layout row>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Nome do contato"
            :value="relatorio.contatos.nomeContato || '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- E-mail -->
      <v-layout row>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="E-mail"
            :value="relatorio.contatos.email || '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

      <!-- Telefone -->
      <v-layout row>
        <v-flex xs12>
          <c-readonly-field style="margin: 0px 30px;" label="Telefone"
            :value="relatorio.contatos.telefone || '-'"></c-readonly-field>
        </v-flex>
      </v-layout>

    </div>
  </div>
</template>

<script>
import ReadonlyField from '@/components/c-readonly-field'
import ReadonlyFieldPreFormat from '@/components/c-readonly-field-pre-format'
import formatAssessor from '@/utils/assessor'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['idProjeto', 'projeto'],
  data: () => ({
    dates: dates,
    formatAssessor: formatAssessor,
    prazo: 30,
    show: false,
    headers0: [
      { text: 'Nome', align: 'left', width: '50%', value: 'tipoClassificacao' },
      { text: 'Descrição', left: 'left', width: '50%', value: 'descricao' }
    ],
    headers1: [
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Função', align: 'left', value: 'funcao.descricao' },
      { text: 'Assessor', align: 'left', value: 'assessor' },
      { text: 'Vínculo', align: 'left', value: 'vinculo' },
      { text: 'CH semanal', align: 'left', value: 'cargaHoraria' },
      { text: 'Data inicial', align: 'left', value: 'dataInicial' },
      { text: 'Data final', align: 'left', value: 'dataFinal' }
    ],
    headers2: [
      { text: 'Nome e descrição sucinta da atividade', align: 'left', width: '60%', value: 'nomeDescricao' },
      { text: 'Início previsto', align: 'left', width: '10%', value: 'dtInicioPrevisto' },
      { text: 'Conclusão prevista', align: 'left', width: '10%', value: 'dtFimPrevisto' },
      { text: 'Início efetivo', align: 'left', width: '10%', value: 'dtInicioEfetivo' },
      { text: 'Conclusão efetiva', align: 'left', width: '10%', value: 'dtFimEfetivo' }
    ],
    headers2b: [
      { text: 'Número', align: 'left', value: 'idProjeto' },
      { text: 'Título', align: 'left', value: 'titulo' },
      { text: 'Classificação Primária', align: 'left', value: 'classificacaoPrimaria.descricao' },
      { text: 'Classificação Secundária', align: 'left', value: 'classificacaoSecundaria.descricao' },
      { text: 'Situação', align: 'left', value: 'situacao.descricao' },
      { text: 'Coordenador', align: 'left', value: 'nomeCoordenador' }
    ],
    headers3: [
      { text: 'Nome do parceiro institucional/colaborador', align: 'left', value: 'nome' },
      { text: 'Descrição da parceria/colaboração', align: 'left', value: 'detalhamento' }
    ],
    headers4: [
      { text: 'Nome da localidade ou instituição', align: 'left', value: 'nome' },
      { text: 'Estado', align: 'left', value: 'ufCidade.descricao' },
      { text: 'Município', align: 'left', value: 'cidade.nomeCidade' },
      { text: 'CEP', align: 'left', value: 'cep' },
      { text: 'Informações adicionais', align: 'left', value: 'detalhes' }
    ],
    headers5: [
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Tipo', align: 'left', value: 'tipoArquivo.descricao' },
      { text: 'Data de inclusão', align: 'left', value: 'dtInclusao' },
      { text: 'Observação', align: 'left', value: 'observacao' }
    ],
    objetivosEspecificosTopicos: [],
    listaTiposPrestacaoServicoSelecionados: [],
    listaTiposPrestacaoServico: [
      'Atendimento ao público em espaços de cultura, ciência e tecnologia',
      'Serviço eventual',
      'Atividades de propriedade intelectual',
      'Exames e laudos técnicos',
      'Atendimento jurídico',
      'Atendimento em saúde humana',
      'Atendimento em saúde animal'
    ],
    listaAtendimentoPublicoEspacosSelecionados: [],
    relatorio: {
      informacoes: {
        idProjeto: 0,
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        tipoPublico: {
          item: 0,
          descricao: ''
        },
        publicoAlvo: 0,
        cargaHoraria: null,
        resumo: '',
        situacao: {
          item: 0,
          descricao: ''
        },
        palavraChave01: '',
        palavraChave02: '',
        palavraChave03: '',
        palavraChave04: null
      },
      extensao: {
        unidade: null
      },
      contatos: {}
    }
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),
    truncate: function (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    toEditar: function () {
      this.$router.push({ name: 'EditarInformacoes', params: { idProjeto: this.projeto.idProjeto } })
    },
    toAvancar: function () {
      this.$router.push({ name: 'ClassificacoesProjeto', params: { idProjeto: this.projeto.idProjeto } })
    }
  },
  mounted: function () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
    projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        this.projeto.dataInicio = dates.format(this.projeto.dataInicio)
        this.projeto.dataConclusao = dates.format(this.projeto.dataConclusao)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' })
    projetos.getRelatorioProjeto(this.idProjeto)
      .then(response => {
        this.relatorio = response.data
        let aux = this.relatorio.extensao.objetivosEspecificos.split(';;')
        for (let item in aux) {
          this.objetivosEspecificosTopicos.push({ nome: aux[item] })
        }
        this.show = true

        // Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia)
        if (this.relatorio.extensao.atendimentoPublicoEspacos === 'S') {
          this.listaTiposPrestacaoServicoSelecionados.push('Atendimento ao público em espaços de cultura, ciência e tecnologia')
        }

        // Tipo de Prestação de Serviço (Serviço eventual)
        if (this.relatorio.extensao.servicoEventual === 'S') {
          this.listaTiposPrestacaoServicoSelecionados.push('Serviço eventual')
        }

        // Tipo de Prestação de Serviço (Atividades de propriedade intelectual)
        if (this.relatorio.extensao.atividadesPropriedadeIntelectual === 'S') {
          this.listaTiposPrestacaoServicoSelecionados.push('Atividades de propriedade intelectual')
        }

        // Tipo de Prestação de Serviço (Exames e laudos técnicos)
        if (this.relatorio.extensao.examesLaudosTecnicos === 'S') {
          this.listaTiposPrestacaoServicoSelecionados.push('Exames e laudos técnicos')
        }

        // Tipo de Prestação de Serviço (Atendimento jurídico)
        if (this.relatorio.extensao.atendimentoJuridico === 'S') {
          this.listaTiposPrestacaoServicoSelecionados.push('Atendimento jurídico')
        }

        // Tipo de Prestação de Serviço (Atendimento em saúde humana)
        if (this.relatorio.extensao.atendimentoSaudeHumana === 'S') {
          this.listaTiposPrestacaoServicoSelecionados.push('Atendimento em saúde humana')
        }

        // Tipo de Prestação de Serviço (Atendimento em saúde animal)
        if (this.relatorio.extensao.atendimentoSaudeAnimal === 'S') {
          this.listaTiposPrestacaoServicoSelecionados.push('Atendimento em saúde animal')
        }

        // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus Culturais)
        if (this.relatorio.extensao.espacosMuseusCulturais === 'S') {
          this.listaAtendimentoPublicoEspacosSelecionados.push('Espaços e Museus Culturais')
        }

        // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus de Ciência e Tecnologia)
        if (this.relatorio.extensao.espacosMuseusCT === 'S') {
          this.listaAtendimentoPublicoEspacosSelecionados.push('Espaços e Museus de Ciência e Tecnologia')
        }

        // Atendimento ao público em espaços de cultura, ciência e tecnologia (Cines-clube)
        if (this.relatorio.extensao.cinesClube === 'S') {
          this.listaAtendimentoPublicoEspacosSelecionados.push('Cines-clube')
        }

        // Atendimento ao público em espaços de cultura, ciência e tecnologia (Outros)
        if (this.relatorio.extensao.outrosEspacos === 'S') {
          this.listaAtendimentoPublicoEspacosSelecionados.push('Outros')
        }
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem })
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' })
      })

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' })
    projetos.getPrazoDias(this.idProjeto)
      .then(response => {
        this.prazo = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' })
      })
  },
  components: {
    'c-readonly-field': ReadonlyField,
    'c-readonly-field-pre-format': ReadonlyFieldPreFormat
  }
}
</script>

<style lang="css">
#v-card-title_label {
  font-size: 14pt;
  margin: 0px 30px;
}

.tipoPrestacaoServico {
  font-size: 1.05em;
  margin-top: 1em;
  margin-bottom: 2em;
  margin-left: 30px;
}

.tipoPrestacaoServico:before {
  content: '• '
}

.alertaEmpresaJunior {
  margin: 0px 30px;
  font-size: 0.85em;
}

@media print {

  @page {
    size: auto;
    margin: 3.5em 0 3.5em 0;
  }

  .btnGerarPDF {
    visibility: hidden;
  }

}
</style>

<style scoped>
.alertaPrazo {
  margin: 0px 30px 15px 30px;
  font-size: 0.85em;
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// relatorio.vue?432ff6bc